(function () {
  const PFAND = window.fsrPfandConfig || {};
  // Selling-plan IDs of the Pfand product — must match the plans Recharge
  // creates on it; re-check after any Recharge reinstall (stale IDs mean the
  // Pfand line is silently dropped from subscription orders).
  const SUBSCRIPTION_MAP = {
    "Alle 2 Wochen": {id: 692945650012, identifier: 'Alle 2 Wochen'},
    "Alle 3 Wochen": {id: 692945879388, identifier: 'Alle 3 Wochen'},
    "Jeden Monat": {id: 692946010460, identifier: 'Jeden Monat'},
    "Alle 6 Wochen": {id: 692945846620, identifier: 'Alle 6 Wochen'},
    "Alle 2 Monate": {id: 692945977692, identifier: 'Alle 2 Monate'},
    "Alle 3 Monate": {id: 692945944924, identifier: 'Alle 3 Monate'},
    "Halbjährlich": {id: 692945912156, identifier: 'Halbjährlich'}
  };

  let running = false;
  let checkoutButtons = [];

  function getQuantity(item) {
    return Number(item.dataset.quantity || item.querySelector('.quantity__input')?.value || 0);
  }

  function calculatePfandRequirements(line_items) {
    const pfandRequirements = {};

    for (let item of line_items) {
      const productId = item.dataset.productId;
      const flaschenCount = Number(item.dataset.flaschen || 0);
      const quantity = getQuantity(item);

      if (productId == PFAND.productId) {
        continue;
      }

      if (flaschenCount > 0 && quantity > 0) {
        const planName = item.hasAttribute('data-selling-plan')
          ? item.getAttribute('data-selling-plan')
          : 'no-subscription';

        if (!pfandRequirements[planName]) {
          pfandRequirements[planName] = { pfand: 0 };
        }
        pfandRequirements[planName].pfand += flaschenCount * quantity;
      }
    }

    return pfandRequirements;
  }

  function shouldUpdatePfand(pfandItemsInCart, pfandRequirements) {
    const actualQty = pfandItemsInCart.reduce((sum, item) => sum + getQuantity(item), 0);
    let desiredQty = 0;

    for (let plan of Object.keys(pfandRequirements)) {
      desiredQty += pfandRequirements[plan].pfand;
    }

    // As in the original implementation, equal totals are treated as correct;
    // selling-plan mismatches are intentionally not compared here.
    return actualQty !== desiredQty;
  }

  async function removeAllPfandItems() {
    const pfandVariantId = Number(PFAND.variantId);
    const cartResponse = await window.cartFetch(`${window.Shopify.routes.root}cart.js`);

    if (!cartResponse.ok) {
      throw new Error(`Failed to fetch cart (${cartResponse.status})`);
    }

    const cart = await cartResponse.json();
    const updates = {};

    for (const item of cart.items) {
      if (item.variant_id === pfandVariantId) {
        updates[item.key] = 0;
      }
    }

    if (Object.keys(updates).length === 0) return;

    const updateResponse = await window.cartFetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    if (!updateResponse.ok) {
      throw new Error(`Failed to remove Pfand items (${updateResponse.status})`);
    }
  }

  async function addPfandItems(items) {
    for (const item of items) {
      const response = await window.cartFetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(item)
      });

      if (!response.ok) {
        throw new Error(`Failed to add Pfand item (${response.status})`);
      }
    }
  }

  function disableCheckoutButtons() {
    checkoutButtons = Array.from(document.querySelectorAll('#CartDrawer-Checkout, #checkout'));
    checkoutButtons.forEach((button) => {
      button.disabled = true;
    });
  }

  function finishPfandUpdate() {
    running = false;
    checkoutButtons.forEach((button) => {
      button.disabled = false;
    });
    checkoutButtons = [];
  }

  const update_pfand = async () => {
    if (running) return false;

    running = true;

    try {
      const line_items = Array.from(document.querySelectorAll('tr.cart-item--kale'));
      if (line_items.length === 0) return false;

      const pfandRequirements = calculatePfandRequirements(line_items);
      const pfandItemsInCart = line_items.filter(
        (item) => item.dataset.productId == PFAND.productId
      );

      if (!shouldUpdatePfand(pfandItemsInCart, pfandRequirements)) {
        return false;
      }

      const pfandItemsToAdd = [];

      for (let [planName, data] of Object.entries(pfandRequirements)) {
        if (data.pfand > 0) {
          const pfandItem = {
            id: PFAND.variantId,
            quantity: data.pfand
          };

          if (planName !== 'no-subscription') {
            const selling_plan_config = SUBSCRIPTION_MAP[planName];
            if (selling_plan_config) {
              pfandItem.selling_plan = selling_plan_config.id;
              pfandItem.properties = { _unique_key: selling_plan_config.identifier };
            } else {
              console.warn(`[Pfand] No selling_plan_id found for plan "${planName}"`);
            }
          }

          pfandItemsToAdd.push(pfandItem);
        }
      }

      disableCheckoutButtons();
      await removeAllPfandItems();

      if (pfandItemsToAdd.length > 0) {
        await addPfandItems(pfandItemsToAdd);
      }

      return true;
    } catch (error) {
      console.error('[Pfand] Error in remove+add sequence:', error);
      return false;
    } finally {
      finishPfandUpdate();
    }
  };

  if (window.CartCoordinator) {
    CartCoordinator.register('pfand', update_pfand);

    const runInitialReconcile = function () {
      CartCoordinator.run();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInitialReconcile, { once: true });
    } else {
      runInitialReconcile();
    }
  } else {
    console.warn('[Pfand] CartCoordinator not found; Pfand reconciliation was not registered');
  }
})();
